import * as React from 'react';

import { ApiError, ApiRequestOptions } from './sustain-api-request';
import useApiCallable from './use-api-callable';
import { useTypedDispatch } from '../reducers';

/**
 * Hook providing a `reader` matching the `api-read-hook` spec
 */
export default function useReader() {
  const dispatch = useTypedDispatch();
  const callApi = useApiCallable();

  return React.useCallback(
    async function reader<R>(
      path: string,
      options: ApiRequestOptions<R> = {},
    ): Promise<R> {
      const response = await callApi<R, any>(path, options, {
        errorHandler: (err) => {
          if (err instanceof ApiError && err.response?.status === 401) {
            dispatch({ type: 'LOGOUT' });
          } else {
            throw err;
          }
        },
      });
      if (!response) {
        throw new Error('Logic error: useReader should always have a response');
      }
      return response.data;
    },
    [callApi, dispatch],
  );
}
